import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { NODE_ENV } from 'const';
import en from './en';
import ru from './ru';
import ar from './ar';
i18next
    .use(initReactI18next)
    .init({
    fallbackLng: 'en',
    lng: window.localStorage.getItem('lang') || 'en',
    supportedLngs: ['en', 'ru', 'ar'],
    load: 'all',
    resources: { en, ru, ar },
    saveMissing: true,
    missingKeyHandler: NODE_ENV === 'development'
        ? (lngs, ns, key, fallbackValue) => {
            // Вывожу в консоль только отсутсвующие переводы,
            // если есть defaultValue и оно существует в консоль сообщение не вывожу
            if (!fallbackValue || key === fallbackValue) {
                console.warn(`%c i18next::translator: missingKey ${lngs} ${ns} ${key}`, 'color: #00FFFF99;');
            }
        }
        : undefined,
});
